
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Input',
  inheritAttrs: false,
  props: {
    label: String,
    modelValue: [Number, String],
  },
});
